import React from "react";
import { useTranslation } from "react-i18next";
import JobDescription from "../components/JobDescription";

const Step4Description: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="step-content">
			<div className="area-container mt-4">
				<JobDescription />
			</div>
		</div>
	);
};

export default Step4Description;
